const state = {
    data: []
}

const mutations = {
    storeBookings (state, payload) {
        state.data = payload
    },
    storeBooking (state, payload) {
        state.data.unshift(payload)
    },
    changeBookingState (state, payload) {
        const curBooking = state.data.find(item => item.id === payload.id)
        curBooking.state = payload.state
    }
}

const actions = {}

const getters = {
    getBookingsNew: state => state.data.filter(item => item.state === 0),
    getBookingsEnded: state => state.data.filter(item => item.state !== 0),
    getBookingNewCount: state => state.data.filter(item => item.state === 0).length
}

export default {
    state,
    mutations,
    actions,
    getters
}
